import React from 'react'
import MyTableFilter_Ext from './_ext'
import {CFormGroup, CInputGroup,CInput,CButton, CInputGroupPrepend, CInputGroupText} from '../../MyCore'
import HUtils from '../../../helpers/Utils'

class MyTableFilter_Search extends MyTableFilter_Ext {   
    constructor(props) {
        super(props);
        this.state={
            value: '',
        };
    }
    _getMyClass=()=>{
        return "mtf-search";
    }
     
    _onChangeSearch=(value)=>{
        const {onChange} = this.props;
        const config = this._getConfig();     
        if(onChange){
            let _value = value;
            if(config.search.nosymbol){
            _value = HUtils.xoaDauInText(value);
            }
            onChange(_value,{
            filter: this._getFilter(_value),        
            });
        }
    }

    _getFilter=(value)=>{
    // console.warn('getFilterForBootstrapTable:',this.state,value);
    if(value){
        let _fieldName = this.getFieldName();
        let _obj = {};
        _obj[_fieldName] = this.getFilter(value,{
        type: "Search",
        })
        return _obj;
    }
    }

    _getConfig=()=>{
        if(this._config){
            return this._config;
        }
        this._config = {
            ...this.getConfigShared(),
            search:{        
                instant: false,
                nosymbol: false,
                ...this.getMoreOfKey("search",{})
            },
            input:{
            ...this.getMoreOfKey("input",{})
            }
        }
        return this._config;
    }

    render() {
        const config = this._getConfig();
        // console.warn("config", config)
        return(
            <CFormGroup className="mtf-search">
            <CInputGroup>
                {
                config.ui.showPre==true &&
                <CInputGroupPrepend>
                    <CInputGroupText><i className="fa fa-search"></i></CInputGroupText> 
                </CInputGroupPrepend>
                }          
                <CInput 
                type="text" 
                name="input-search" 
                placeholder={config.placeholder} 
                onKeyPress={(ev)=>{
                    if(ev.key == 'Enter'){
                    this._onChangeSearch(ev.currentTarget.value);
                    }
                }}
                defaultValue={this.state.value}
                onChange={(ev)=> {
                    this._searchText = ev.currentTarget.value;
                    if(config.search.instant==true){
                    this._onChangeSearch(ev.currentTarget.value);
                    }
                    else if(this._searchText==""){
                    this._onChangeSearch(this._searchText);
                    }
                }}
                // value={this.state.searchText}
                {...config.input}
                />
                {
                config.ui.showSuffix && 
                <div className="input-group-suffix">
                    <CButton style={{zIndex:0}} color="primary" onClick={()=>{
                    this._onChangeSearch(this._searchText);
                    }}><i className="fa fa-search"></i></CButton>
                </div>
                }          
            </CInputGroup>
            </CFormGroup>
        )
    }
    
}

export default MyTableFilter_Search